// extracted by mini-css-extract-plugin
export var description = "DevResourcesList-module__description___t4mVP";
export var linkPaneContainer = "DevResourcesList-module__linkPaneContainer___MW2uO";
export var listContainer = "DevResourcesList-module__listContainer___CHnVF";
export var title = "DevResourcesList-module__title___I3v-r";
export var welcomePartnerPane = "DevResourcesList-module__welcomePartnerPane___N+by0";